import React, { Component } from "react";
import { connect } from "react-redux";

import {
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle
} from "actions";
import {
  fetchNonCategorizedTaskTypeCount,
  fetchCapacityPlaningProduction
} from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";

import CapacityPlaningProduction from "./CapacityPlaningProduction";

class CapacityPlaningProductionPage extends Component {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen };
  }

  componentDidMount() {
    const { dispatch, subMenuDirection, items } = this.props;

    dispatch(setCurrentNavPage("CAPACITY_PLANING_PROD_PAGE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(false));

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });

    if (items.length === 0) {
      dispatch(fetchCapacityPlaningProduction());
      dispatch(fetchNonCategorizedTaskTypeCount());
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
  }

  render() {
    return (
      <div className={`page-content`}>
        <CapacityPlaningProduction uen={this.state.organizationUen} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  organization: state.timeSheet.organization,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization,
  items: state.capacityPlaning.production.data
});

export default connect(mapStateToProps)(CapacityPlaningProductionPage);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CapacityPlaningProductionPage.js